import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { Pagination, Autoplay, Navigation } from 'swiper/modules';

const SoftwareDevelopment = () => {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            {/* Breadcrumb Section */}
            <section className="breadcrumb-hero">
                <div className="breadcrumb-overlay"></div>
                <div className="breadcrumb-content">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <h1 className="breadcrumb-title">
                                    Software <span className="breadcrumb-highlight">Development</span>
                                </h1>
                                <Link to="/services" style={{ textDecoration: 'none' }}>
                                    <button className="breadcrumb-btn">
                                        <span>Our Services</span>
                                        <span className="breadcrumb-arrow">
                                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M4.16669 10H15.8334M15.8334 10L10 4.16669M15.8334 10L10 15.8334" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>
                                        </span>
                                    </button>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="breadcrumb-pattern"></div>
            </section>

            {/* Hero Section */}
            <section className="digital-presence-hero">
                <div className="container">
                    <div className="row align-items-center g-5">
                        <div className="col-lg-6">
                            <div className="hero-badge">
                                <span className="badge-dot"></span>
                                Leading Software Development Company
                            </div>
                            <h2 className="intro-about-heading">
                                Build Powerful Software
                                <span className="text-gradient"> That Transforms Businesses</span>
                            </h2>
                            <p className="hero-description">
                                Partner with <span className="text-blue-highlight">expert software engineers</span> to create scalable, robust, and innovative software solutions. From enterprise applications to SaaS platforms, we bring your vision to life with cutting-edge technology.
                            </p>
                            <div className="hero-buttons">
                                <button className="btn-hero-secondary">
                                    Start Your Project →
                                </button>
                            </div>
                            <div className="hero-stats">
                                <div className="stat-card">
                                    <h3 className="stat-number">800+</h3>
                                    <p className="stat-label">Projects Delivered</p>
                                </div>
                                <div className="stat-card">
                                    <h3 className="stat-number">50+</h3>
                                    <p className="stat-label">Expert Developers</p>
                                </div>
                                <div className="stat-card">
                                    <h3 className="stat-number">98%</h3>
                                    <p className="stat-label">Success Rate</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="hero-image-container">
                                <img src={require('../../assets/images/software-development.jpg')} alt="Software Development Hero" className="img-fluid rounded shadow-md" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Comprehensive Software Development Services Section */}
            <section className="comprehensive-design-section py-5">
                <div className="container">
                    <div className="text-center mb-5">
                        <div className="expertise-badge">
                            Our Expertise
                        </div>
                        <h2 className="comprehensive-title">
                            Comprehensive Software Development Services
                        </h2>
                        <p className="comprehensive-subtitle">
                            End-to-end software solutions tailored to your business needs
                        </p>
                    </div>

                    <div className="row g-4">
                        {/* Custom Software Development */}
                        <div className="col-lg-4 col-md-6">
                            <div className="design-solution-card">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">⚙️</span>
                                </div>
                                <h3 className="solution-card-title">Custom Software Development</h3>
                                <p className="solution-card-description">
                                    Bespoke software solutions designed specifically for your unique business requirements and workflows
                                </p>
                                <a href="#" className="solution-learn-more">
                                    Learn More →
                                </a>
                            </div>
                        </div>

                        {/* Enterprise Software Solutions */}
                        <div className="col-lg-4 col-md-6">
                            <div className="design-solution-card">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">🏢</span>
                                </div>
                                <h3 className="solution-card-title">Enterprise Solutions</h3>
                                <p className="solution-card-description">
                                    Scalable enterprise-grade applications with robust architecture and seamless integration capabilities
                                </p>
                                <a href="#" className="solution-learn-more">
                                    Learn More →
                                </a>
                            </div>
                        </div>

                        {/* SaaS Development */}
                        <div className="col-lg-4 col-md-6">
                            <div className="design-solution-card highlighted">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">☁️</span>
                                </div>
                                <h3 className="solution-card-title">SaaS Development</h3>
                                <p className="solution-card-description">
                                    Cloud-based Software-as-a-Service platforms with multi-tenancy, subscriptions, and analytics
                                </p>
                                <a href="#" className="solution-learn-more">
                                    Learn More →
                                </a>
                            </div>
                        </div>

                        {/* API Development & Integration */}
                        <div className="col-lg-4 col-md-6">
                            <div className="design-solution-card">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">🔗</span>
                                </div>
                                <h3 className="solution-card-title">API Development</h3>
                                <p className="solution-card-description">
                                    RESTful and GraphQL API development with secure authentication and seamless third-party integrations
                                </p>
                                <a href="#" className="solution-learn-more">
                                    Learn More →
                                </a>
                            </div>
                        </div>

                        {/* Legacy Modernization */}
                        <div className="col-lg-4 col-md-6">
                            <div className="design-solution-card">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">🔄</span>
                                </div>
                                <h3 className="solution-card-title">Legacy Modernization</h3>
                                <p className="solution-card-description">
                                    Transform outdated systems into modern, efficient applications with improved performance and security
                                </p>
                                <a href="#" className="solution-learn-more">
                                    Learn More →
                                </a>
                            </div>
                        </div>

                        {/* Software Testing & QA */}
                        <div className="col-lg-4 col-md-6">
                            <div className="design-solution-card">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">✅</span>
                                </div>
                                <h3 className="solution-card-title">QA & Testing</h3>
                                <p className="solution-card-description">
                                    Comprehensive testing services including automated, manual, performance, and security testing
                                </p>
                                <a href="#" className="solution-learn-more">
                                    Learn More →
                                </a>
                            </div>
                        </div>
                    </div>

                    <div className="text-center mt-5">
                        <button className="btn-start-project">
                            Build Your Software →
                        </button>
                    </div>
                </div>
            </section>

            {/* Why Choose Profit Technologies */}
            <section className="bespoke-section py-5" style={{ backgroundColor: '#f8f9fa' }}>
                <div className="container">
                    <div className="row align-items-center g-5">
                        <div className="col-lg-6">
                            <h2 className="section-main-title mb-4">
                                Why Choose Profit Technologies for Software Development?
                            </h2>
                            <p className="section-description">
                                <strong>Your Trusted Development Partner</strong>
                            </p>
                            <p className="section-description">
                                At <strong>Profit Technologies</strong>, we combine technical excellence with agile methodologies to deliver software that exceeds expectations. Our team of seasoned developers, architects, and quality engineers has successfully delivered 800+ projects across diverse industries.
                            </p>
                            <p className="section-description">
                                We don't just write code—we build solutions that solve real business problems. Our customer-centric approach ensures transparent communication, timely delivery, and software that scales with your business growth.
                            </p>
                            <p className="section-description">
                                <strong>What makes us different:</strong>
                            </p>
                            <ul className="section-description" style={{ paddingLeft: '20px' }}>
                                <li>✓ 8+ years of software development expertise across all industries</li>
                                <li>✓ Full-stack developers proficient in modern frameworks and languages</li>
                                <li>✓ Agile development with 2-week sprints and regular demos</li>
                                <li>✓ Clean, maintainable code following industry best practices</li>
                                <li>✓ Rigorous testing ensuring 99.9% uptime and reliability</li>
                                <li>✓ Post-launch support and continuous improvement</li>
                                <li>✓ Transparent pricing with no hidden costs</li>
                            </ul>
                        </div>
                        <div className="col-lg-6">
                            <div className="bespoke-image-wrapper">
                                <img
                                    src="https://images.unsplash.com/photo-1461749280684-dccba630e2f6?w=800&q=80"
                                    alt="Profit Technologies Software Development"
                                    className="img-fluid rounded"
                                    style={{ boxShadow: '0 10px 40px rgba(0,0,0,0.1)' }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Technologies & Platforms */}
            <section className="comprehensive-design-section py-5">
                <div className="container">
                    <div className="text-center mb-5">
                        <div className="expertise-badge">
                            Technology Stack
                        </div>
                        <h2 className="comprehensive-title">
                            Technologies & Frameworks We Master
                        </h2>
                        <p className="comprehensive-subtitle">
                            Cutting-edge tools and technologies for modern software development
                        </p>
                    </div>

                    <div className="row g-4">
                        {/* Frontend Technologies */}
                        <div className="col-lg-3 col-md-6">
                            <div className="design-solution-card">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">⚛️</span>
                                </div>
                                <h3 className="solution-card-title">Frontend</h3>
                                <p className="solution-card-description">
                                    React, Angular, Vue.js, Next.js, TypeScript for dynamic user interfaces
                                </p>
                            </div>
                        </div>

                        {/* Backend Technologies */}
                        <div className="col-lg-3 col-md-6">
                            <div className="design-solution-card">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">🔧</span>
                                </div>
                                <h3 className="solution-card-title">Backend</h3>
                                <p className="solution-card-description">
                                    Node.js, Python, Java, .NET, PHP, Ruby for scalable server-side applications
                                </p>
                            </div>
                        </div>

                        {/* Mobile Development */}
                        <div className="col-lg-3 col-md-6">
                            <div className="design-solution-card">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">📱</span>
                                </div>
                                <h3 className="solution-card-title">Mobile</h3>
                                <p className="solution-card-description">
                                    React Native, Flutter, Swift, Kotlin for iOS and Android apps
                                </p>
                            </div>
                        </div>

                        {/* Database */}
                        <div className="col-lg-3 col-md-6">
                            <div className="design-solution-card">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">🗄️</span>
                                </div>
                                <h3 className="solution-card-title">Databases</h3>
                                <p className="solution-card-description">
                                    PostgreSQL, MySQL, MongoDB, Redis, DynamoDB for data management
                                </p>
                            </div>
                        </div>

                        {/* Cloud & DevOps */}
                        <div className="col-lg-3 col-md-6">
                            <div className="design-solution-card">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">☁️</span>
                                </div>
                                <h3 className="solution-card-title">Cloud & DevOps</h3>
                                <p className="solution-card-description">
                                    AWS, Azure, GCP, Docker, Kubernetes, CI/CD pipelines
                                </p>
                            </div>
                        </div>

                        {/* AI & Machine Learning */}
                        <div className="col-lg-3 col-md-6">
                            <div className="design-solution-card">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">🤖</span>
                                </div>
                                <h3 className="solution-card-title">AI/ML</h3>
                                <p className="solution-card-description">
                                    TensorFlow, PyTorch, OpenAI, ML models and intelligent automation
                                </p>
                            </div>
                        </div>

                        {/* Blockchain */}
                        <div className="col-lg-3 col-md-6">
                            <div className="design-solution-card">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">⛓️</span>
                                </div>
                                <h3 className="solution-card-title">Blockchain</h3>
                                <p className="solution-card-description">
                                    Ethereum, Solidity, Smart Contracts, Web3 for decentralized apps
                                </p>
                            </div>
                        </div>

                        {/* Testing Tools */}
                        <div className="col-lg-3 col-md-6">
                            <div className="design-solution-card">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">🧪</span>
                                </div>
                                <h3 className="solution-card-title">Testing</h3>
                                <p className="solution-card-description">
                                    Jest, Selenium, Cypress, JUnit for automated testing and QA
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Our Development Process */}
            <section className="comprehensive-design-section py-5" style={{ backgroundColor: '#ffffff' }}>
                <div className="container">
                    <div className="text-center mb-5">
                        <div className="expertise-badge">
                            Our Approach
                        </div>
                        <h2 className="comprehensive-title">
                            Our Agile Development Process
                        </h2>
                        <p className="comprehensive-subtitle">
                            A proven methodology that ensures quality, speed, and transparency
                        </p>
                    </div>

                    <div className="row g-4">
                        {/* Requirements Analysis */}
                        <div className="col-lg-4 col-md-6">
                            <div className="design-solution-card">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">📋</span>
                                </div>
                                <h3 className="solution-card-title">1. Requirements Analysis</h3>
                                <p className="solution-card-description card-text-dst">
                                    Deep dive into your business needs, user stories, and technical requirements
                                </p>
                            </div>
                        </div>

                        {/* Architecture Design */}
                        <div className="col-lg-4 col-md-6">
                            <div className="design-solution-card">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">🏗️</span>
                                </div>
                                <h3 className="solution-card-title">2. Architecture Design</h3>
                                <p className="solution-card-description card-text-dst">
                                    Create scalable system architecture with technology stack selection and database design
                                </p>
                            </div>
                        </div>

                        {/* UI/UX Design */}
                        <div className="col-lg-4 col-md-6">
                            <div className="design-solution-card">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">🎨</span>
                                </div>
                                <h3 className="solution-card-title">3. UI/UX Design</h3>
                                <p className="solution-card-description card-text-dst">
                                    Intuitive, user-friendly interfaces with wireframes, mockups, and prototypes
                                </p>
                            </div>
                        </div>

                        {/* Development Sprints */}
                        <div className="col-lg-4 col-md-6">
                            <div className="design-solution-card">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">💻</span>
                                </div>
                                <h3 className="solution-card-title">4. Agile Development</h3>
                                <p className="solution-card-description card-text-dst">
                                    2-week sprints with continuous integration and regular demos for feedback
                                </p>
                            </div>
                        </div>

                        {/* Testing & QA */}
                        <div className="col-lg-4 col-md-6">
                            <div className="design-solution-card">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">🧪</span>
                                </div>
                                <h3 className="solution-card-title">5. Testing & QA</h3>
                                <p className="solution-card-description card-text-dst">
                                    Comprehensive testing including unit, integration, performance, and security tests
                                </p>
                            </div>
                        </div>

                        {/* Deployment & Support */}
                        <div className="col-lg-4 col-md-6">
                            <div className="design-solution-card">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">🚀</span>
                                </div>
                                <h3 className="solution-card-title">6. Launch & Support</h3>
                                <p className="solution-card-description card-text-dst">
                                    Seamless deployment with ongoing maintenance, updates, and technical support
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Industries We Serve */}
            <section className="comprehensive-design-section py-5" style={{ backgroundColor: '#f8f9fa' }}>
                <div className="container">
                    <div className="text-center mb-5">
                        <div className="expertise-badge">
                            Industries
                        </div>
                        <h2 className="comprehensive-title">
                            Industries We Serve
                        </h2>
                        <p className="comprehensive-subtitle">
                            Software solutions across diverse sectors
                        </p>
                    </div>

                    <div className="row g-4">
                        {/* Healthcare */}
                        <div className="col-lg-3 col-md-6">
                            <div className="design-solution-card">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">🏥</span>
                                </div>
                                <h3 className="solution-card-title">Healthcare</h3>
                                <p className="solution-card-description text-muted">
                                    HIPAA-compliant healthcare management systems and telemedicine platforms
                                </p>
                            </div>
                        </div>

                        {/* Finance */}
                        <div className="col-lg-3 col-md-6">
                            <div className="design-solution-card">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">💰</span>
                                </div>
                                <h3 className="solution-card-title">Finance & Banking</h3>
                                <p className="solution-card-description text-muted">
                                    Secure fintech solutions, payment gateways, and banking applications
                                </p>
                            </div>
                        </div>

                        {/* E-commerce */}
                        <div className="col-lg-3 col-md-6">
                            <div className="design-solution-card">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">🛒</span>
                                </div>
                                <h3 className="solution-card-title">E-commerce</h3>
                                <p className="solution-card-description text-muted">
                                    Scalable online marketplaces and shopping platforms with payment integration
                                </p>
                            </div>
                        </div>

                        {/* Education */}
                        <div className="col-lg-3 col-md-6">
                            <div className="design-solution-card">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">🎓</span>
                                </div>
                                <h3 className="solution-card-title">Education</h3>
                                <p className="solution-card-description text-muted">
                                    E-learning platforms, LMS, and educational management systems
                                </p>
                            </div>
                        </div>

                        {/* Real Estate */}
                        <div className="col-lg-3 col-md-6">
                            <div className="design-solution-card">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">🏠</span>
                                </div>
                                <h3 className="solution-card-title">Real Estate</h3>
                                <p className="solution-card-description text-muted">
                                    Property management systems and real estate marketplace platforms
                                </p>
                            </div>
                        </div>

                        {/* Logistics */}
                        <div className="col-lg-3 col-md-6">
                            <div className="design-solution-card">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">🚚</span>
                                </div>
                                <h3 className="solution-card-title">Logistics</h3>
                                <p className="solution-card-description text-muted">
                                    Supply chain management and fleet tracking solutions
                                </p>
                            </div>
                        </div>

                        {/* Hospitality */}
                        <div className="col-lg-3 col-md-6">
                            <div className="design-solution-card">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">🏨</span>
                                </div>
                                <h3 className="solution-card-title">Hospitality</h3>
                                <p className="solution-card-description text-muted">
                                    Booking systems, hotel management, and guest experience platforms
                                </p>
                            </div>
                        </div>

                        {/* Entertainment */}
                        <div className="col-lg-3 col-md-6">
                            <div className="design-solution-card">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">🎬</span>
                                </div>
                                <h3 className="solution-card-title">Media & Entertainment</h3>
                                <p className="solution-card-description text-muted">
                                    Streaming platforms, content management, and social media applications
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default SoftwareDevelopment;
